export default __webpack_public_path__ + "static/media/Girdle of the Savage Slaughter.a585ef56.jpg";